"use strict";

import Vue from 'vue';
import axios from "axios";
import store from '../store'


Vue.prototype.$http = axios;
const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
  console.log(Vue.prototype.$http.defaults.headers)
}

let config = {
  baseURL: process.env.VUE_APP_BASE_URL || ""
};
const _axios = axios.create(config);

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

axios.interceptors.request.use(
  function(config) {

    store.dispatch('validation/clearErrors')
    return config;
  },
  function(error) {

    return Promise.reject(error);
  }
);


axios.interceptors.response.use(
  function(response) {

    return response;
  },
  function(error) {

    if (error.response.status === 422) {
      store.dispatch('validation/setErrors', error.response.data.errors)
    }
    return Promise.reject(error);
  }
);


Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
